
import React from 'react';
import { FacilityOrderNewFlowInventoryEditEmergencySupplyDaysModalTemplate} from 'themes/application/facility-order-new-flow-inventory/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { FacilityOrderNewFlowInventoryEditEmergencySupplyDaysModalStore } from 'application/facility-order-new-flow-inventory/stores';

@setCurrentView((rootStore, componentProps) => new FacilityOrderNewFlowInventoryEditEmergencySupplyDaysModalStore(rootStore, componentProps), 'facilityOrderNewFlowInventoryEditEmergencySupplyDaysModalStore')
@observer
class FacilityOrderNewFlowInventoryEditEmergencySupplyDaysModal extends React.Component {
    render() {
        return <FacilityOrderNewFlowInventoryEditEmergencySupplyDaysModalTemplate {...this.props} />
    }
}

export default FacilityOrderNewFlowInventoryEditEmergencySupplyDaysModal;
